import {Loader} from "@chayka/ui";

export const AuthGateLoader = () => {
  return (
    <div className="w-full h-full flex justify-center items-center">
      <Loader />
    </div>
  );
};
